module.exports = __webpack_public_path__ + "images/emails/logo-postmark-0b121d8f.gif";